<div class="menu-row">
  <mode-labeled-menu
    data-test="display-unit-menu"
    class="menu-cell"
    label="Display unit"
    menuClass="number-format-pane-menu"
    [selected]="selectedDisplayUnit"
    [menuItems]="displayUnitMenuItems"
    (menuChange)="onChangeUnit($event)"
  ></mode-labeled-menu>
</div>

<div class="menu-row">
  <mode-labeled-menu
    data-test="thousands-separator-menu"
    class="menu-cell"
    label="Thousands separator"
    menuClass="number-format-pane-menu"
    [selected]="selectedThousandsSeparator"
    [menuItems]="thousandsSeparatorMenuItems"
    (menuChange)="onChangeSeparator($event)"
  ></mode-labeled-menu>
  <mode-labeled-menu
    data-test="thousands-grouping-menu"
    class="menu-cell"
    label="Thousands grouping"
    menuClass="number-format-pane-menu"
    [selected]="selectedThousandsGrouping"
    [menuItems]="thousandsGroupingMenuItems"
    (menuChange)="onChangeGrouping($event)"
  ></mode-labeled-menu>
</div>

<div class="menu-row">
  <mode-labeled-menu
    data-test="decimal-separator-menu"
    class="menu-cell"
    label="Decimal symbol"
    menuClass="number-format-pane-menu"
    [selected]="selectedDecimalSymbol"
    [menuItems]="decimalSymbolMenuItems"
    (menuChange)="onChangeSymbol($event)"
  ></mode-labeled-menu>
  <div class="menu-cell">
    <label class="form-control-label">Decimal places</label>
    <input
      data-test="decimal-precision"
      [ngModel]="format.precision"
      (ngModelChange)="onChangePrecision($event)"
      placeholder="Auto"
      class="form-control form-control-sm precision"
      type="number"
      step="1"
      max="12"
      min="0"
    />
    <div class="subtext">Between 0-12</div>
  </div>
</div>
